import { render, staticRenderFns } from "./FormDocumentsValidation.vue?vue&type=template&id=346d304c&scoped=true&lang=pug&"
import script from "./FormDocumentsValidation.vue?vue&type=script&lang=js&"
export * from "./FormDocumentsValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346d304c",
  null
  
)

export default component.exports